import React, { useState, useEffect } from "react";
import { getData, postData } from "../../../components/helpers/Data";
import { Spinner } from "../../../components/helpers/Spinner";
import MessageModal from "../../../components/helpers/Modal2";
import { toInputUpperCase } from "../../../components/helpers/toInputUpperCase";
import Modal5 from "../../../components/helpers/Modal5";
import { userSaveDetails } from "../../../components/helpers/UserSaveDetails";
import { Link } from "react-router-dom";

const AddUserGroup = () => {


  //create array for logs when renewing corp
  const logData = userSaveDetails(4);

  //module variables
  const [userGroups, setUserGroups] = useState([]);
  const [appendedUserGroup, setAppendedUserGroup] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [responseModal, setResponseModal] = useState(false);
  const [response, setResponse] = useState(false);
  const [message, setMessage] = useState(false);

  useEffect(() => {
    getData("fetch_user_groups")
      .then((data) => {
        setUserGroups(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  // append bank
  const appendUserGroupRow = (e) => {
    e.preventDefault();
    const row = {
      id: new Date().getTime().toString(),
      new: (
        <>
          <td>
            <input type="text" disabled />
          </td>
          <td>
            <input
              type="text"
              name="user_group_added[]"
              className={"form-control"}
              onInput={toInputUpperCase}
            />
          </td>
          <td>
            <button
              className="btn text-danger btn-sm"
              onClick={(e) => removeUserGroup(row.id, e)}
            >
              <i className="fas fa-trash fa-sm"></i>
            </button>
          </td>
        </>
      ),
    };

    setAppendedUserGroup((appendedUserGroup) => {
      return [...appendedUserGroup, row];
    });
  };
  //remove bank row
  const removeUserGroup = async (id, e) => {
    e.preventDefault();
    setAppendedUserGroup((appendedUserGroup) => {
      return appendedUserGroup.filter((row) => row.id !== id);
    });
  };
  //save bank
  const saveUserGroup = (e) => {
    e.preventDefault();
    //const user_group_added[] = document.getElementById("user_group_added").value;
    const errors_arr = [];
    //loop through table and check for null bank detail entries
    const tbl_length = document.getElementById("user_group_tbl").rows.length;
    console.log(tbl_length);

    const tbl = document.querySelector("#user_group_tbl tbody").children;
    for (let trs of tbl) {
      const user_group_added = trs.children[1].children[0].value;
      if (!user_group_added) {
        errors_arr.push("Notice ! Enter User group Details");
      }
    }
    if (errors_arr.length > 0) {
      setMessage("Notice ! Enter User group Details");
      setIsMessageModal(true);
    } else {
      const frmData = new FormData(document.getElementById("user_group_form"));

      //append access log details
      frmData.append("user_id", logData[0]);
      frmData.append("accessed_item", logData[1]);
      frmData.append("browser_type", logData[2]);
      frmData.append("os_type", logData[3]);

      postData(frmData, "save_user_group")
        .then((data) => {
          // return console.log(data);
          setResponse(data[0]);
          setResponseModal(true);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  //close message modal
  const closeMessageModal = () => {
    setResponseModal(false);
    window.location.reload();
  };
  return (
    <div>
      <div className="container">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Add user group
              </li>
            </ol>
          </nav>
          <hr />
        </div>
        <div className="card col-md-12">
          <button className="btn btn-success" onClick={appendUserGroupRow}>
            Add
          </button>
          <form id="user_group_form" onSubmit={saveUserGroup}>
            <div className={"row justify-content-center"}>
              <table
                className="table table-bordered"
                style={{ maxHeight: "300px" }}
                id={"user_group_tbl"}
              >
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>User Group</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {userGroups.map((dt) => {
                    return (
                      <tr>
                        <td>
                          <input
                            type="text"
                            name="code[]"
                            className={"form-control text-center"}
                            defaultValue={dt.code}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="user_group[]"
                            className={"form-control"}
                            style={{ width: "400px" }}
                            defaultValue={dt.user_group}
                            onInput={toInputUpperCase}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {appendedUserGroup.map((data) => {
                    return <tr key={data.id}>{data.new}</tr>;
                  })}
                </tbody>
              </table>
            </div>
            <div className={"row justify-content-center"}>
              <Spinner />
            </div>
            <div className={"row justify-content-center"}>
              <button className="btn btn-primary col-md-1" type="submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
      {/*Message modal*/}
      <Modal5
        modalIsOpen={messageModal}
        // background="#0047AB"
        body={
          <div>
            <div className={"row"}>
              <p className="text-blue font-weight-bold h4">{message}</p>
            </div>
          </div>
        }
        buttons={
          <div className={"row"}>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => setIsMessageModal(false)}
            >
              OK
            </button>
          </div>
        }
      />
      {/*Response modal*/}
      <MessageModal
        modalIsOpen={responseModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={<p className="text-white font-weight-bold h4">{response}</p>}
      />
    </div>
  );
};

export default AddUserGroup;
